// パネル type と列ID/列名から columninfo・columns を引く共通ロジック。
// 本文は Kakousiji.js の実装をそのまま移設し、state 参照のみ getter 経由にしている。
export function createTypeColumnResolver(deps) {
    const {
        isEmpty,
        getColumnInfo,
        getColumns,
        normalizeTypeKey,
        normalizeColumnIdSuffix,
        normalizeLabelKey
    } = deps;

    function resolveTypeCandidates(type) {
        const t = normalizeTypeKey(type);
        if (t === "") return [];
        return [t];
    }
    function resolveTypeColumnIdBySuffix(type, suffixCandidates) {
        const columninfo = getColumnInfo();
        if (!Array.isArray(columninfo) || columninfo.length === 0) return "";
        const types = resolveTypeCandidates(type);
        const list = columninfo.filter((c) => types.includes(String(c.type ?? "").trim().toLowerCase()));
        if (list.length === 0) return "";
        const keys = (Array.isArray(suffixCandidates) ? suffixCandidates : [])
            .map(v => String(v ?? "").toLowerCase().trim())
            .filter(v => v !== "");
        if (keys.length === 0) return "";
        for (let i = 0; i < keys.length; i++) {
            const hit = list.find(c => normalizeColumnIdSuffix(c.columnid) === keys[i]);
            if (!isEmpty(hit)) return String(hit.columnid ?? "");
        }
        return "";
    }
    function resolveTypeColumnIdByName(type, nameCandidates) {
        const columninfo = getColumnInfo();
        if (!Array.isArray(columninfo) || columninfo.length === 0) return "";
        const types = resolveTypeCandidates(type);
        const list = columninfo.filter((c) => types.includes(String(c.type ?? "").trim().toLowerCase()));
        if (list.length === 0) return "";
        const keys = (Array.isArray(nameCandidates) ? nameCandidates : [])
            .map(v => normalizeLabelKey(v))
            .filter(v => v !== "");
        if (keys.length === 0) return "";
        for (let i = 0; i < keys.length; i++) {
            const hit = list.find(c => normalizeLabelKey(c.columnnm) === keys[i]);
            if (!isEmpty(hit)) return String(hit.columnid ?? "");
        }
        return "";
    }
    function resolveTypeColumnNameById(type, columnId) {
        const columninfo = getColumnInfo();
        const columns = getColumns();
        if (isEmpty(columnId)) return "";
        const types = resolveTypeCandidates(type);
        const key = String(columnId ?? "").trim().toUpperCase();
        if (Array.isArray(columninfo) && columninfo.length !== 0) {
            const hit = columninfo.find((c) => {
                const t = String(c.type ?? "").trim().toLowerCase();
                const cid = String(c.columnid ?? "").trim().toUpperCase();
                return types.includes(t) && cid === key;
            });
            if (!isEmpty(hit) && !isEmpty(hit.columnnm)) return String(hit.columnnm ?? "").trim();
        }
        if (Array.isArray(columns) && columns.length !== 0) {
            const hit2 = columns.find((c) => {
                const t = String(c.type ?? "").trim().toLowerCase();
                const cid = String(c.columnid ?? "").trim().toUpperCase();
                return types.includes(t) && cid === key;
            });
            if (!isEmpty(hit2) && !isEmpty(hit2.columnnm)) return String(hit2.columnnm ?? "").trim();
        }
        return "";
    }

    return {
        resolveTypeCandidates,
        resolveTypeColumnIdBySuffix,
        resolveTypeColumnIdByName,
        resolveTypeColumnNameById
    };
}
